<template>
  <v-scale-transition>
    <kits-panel
      :kits-items="AdKits"
      :breadcrumbs="breadcrumbs"
    >
      <h3 class="headline grey--text text-xs-center hidden-sm-and-down">
        {{ title }}
      </h3>
    </kits-panel>
  </v-scale-transition>
</template>

<script>
const title = 'Area Dealer'

export default {
  components: {
    KitsPanel: () => import(/* webpackChunkName: "kitsPanel" */ '@/components/KitsPanel'),
  },
  data () {
    return {
      breadcrumbs: [
        {
          text: title, disabled: true,
        },
      ],
      AdKits: [
        {
          icon: 'mdi-file-document',
          path: '/contractAD',
          title: 'Contract',
          desc: 'Area Dealer Contract',
        },
        {
          icon: 'mdi-file-marker-outline',
          path: '/adRegion',
          title: 'States and District',
          desc: 'Area Dealer States and District ',
        },
      ],
      title,
    }
  },
}
</script>
